import React, { useState } from "react";
import RootLayout from "./root-layout";
import MainImage from "./MainImage";
import { Link, useNavigate } from "react-router-dom";
import { HiOutlineMail } from "react-icons/hi";

import axiosInstance from "../../apiInstances/axiosInstance";
import { toast } from "react-toastify";


const ForgetPassword = () => {
  const nevigate = useNavigate();
  const [email, setEmail] = useState("");

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const obj = {
      email: email,
    };
    axiosInstance
      .post("forget_password", obj)
      .then((responce) => {
        if (responce.data.status) {
          nevigate("/signin");
          toast.success(responce.data.message);
        } else {
          // nevigate("/login");
          toast.error(responce.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <RootLayout className="">
        <MainImage className="mt-8" />

        <div className="bg-white w-full max-w-xl rounded-3xl md:mt-16 mt-5 md:p-16 p-5 flex-center flex-col ">
          <h1 className="text-regal-blue font-josefin font-bold  md:text-4xl text-3xl text-center text-[#294894]">
            Forget Password
          </h1>
          <div className="md:mt-10 mt-8">
            <div>
              <div className="relative mb-6 border w-full rounded-lg ">
                <div className="flex items-center text-[#A9A9A9]">
                  <span>
                    <HiOutlineMail size={25} className=" ml-2" />
                  </span>
                  <input
                    type="text"
                    id="input-group-1"
                    className="form-input-filed font-medium font-sans outline-none w-full py-2 px-2 rounded-lg"
                    placeholder="User email"
                    name="email"
                    value={email}
                    onChange={handleEmailChange}
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            onClick={(event) => {
              handleSubmit(event);
            }}
            className="justify-center items-center flex mt-10"
          >
            <button className="bg-[#22345C] font-sans rounded-lg py-3 px-8 font-medium text-lg text-[#FFFFFF] leading-normal ">
              Send Link
            </button>
          </div>
          <Link
            to="/reset"
            className="font-medium text-[#030239] font-sans justify-center flex mt-6 mb-2"
          >
            Reset password ?
          </Link>
        </div>
      </RootLayout>
    </>
  );
};

export default ForgetPassword;
